// extracted by mini-css-extract-plugin
export default {"wrapper":"_CompanyAndTitle_wrapper__dN6wT","uobLogo":"_CompanyAndTitle_uobLogo__M2sjE"};